import React from 'react';
import TooltipSystemV2 from '../../DesignSystem/TooltipSystemV2/TooltipSystemV2';
import { Member } from '../types';
import MemberAvatar from '../MemberAvatar/MemberAvatar.tsx';
import MoreMembersDropdown from '../MoreMembersDropdown/MoreMembersDropdown.tsx';
import './MembersList.scss';
import MemberPreviewTooltip from '../MemberPreviewTooltip/MemberPreviewTooltip.tsx';

interface MembersListProps {
  members: Member[];
  maxMembers?: number;
}

const MembersList = ({ members, maxMembers = 7 }: MembersListProps) => {
  const showMoreMembersDropdown = members.length > maxMembers;
  let membersToShow = members;
  if (showMoreMembersDropdown) {
    membersToShow = members.slice(0, maxMembers - 1);
  }

  return (
    <div className="members-list">
      {showMoreMembersDropdown && (
        <div className="members-list__item">
          <MoreMembersDropdown members={members.slice(maxMembers - 1)} />
        </div>
      )}
      {membersToShow.map((member) => (
        <TooltipSystemV2
          title={<MemberPreviewTooltip member={member} />}
          key={member.connectionId}
          placement="bottom">
          <div className="members-list__item">
            <MemberAvatar member={member} />
          </div>
        </TooltipSystemV2>
      ))}
    </div>
  );
};

export default MembersList;
